const semver = require('semver');

module.exports = semver.satisfies(process.version, '>=16.9.0');



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/lib/rsaPssKeyDetailsSupported.js
// module id = 1914
// module chunks = 1